import { Check, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { isValidNumber } from "../../utils/carFormValidators";

interface KMSUpdateCardProps {
  onSubmit: (carData: any) => void;
  onClose: () => void;
}

export const KMSUpdateCard = ({ onSubmit, onClose }: KMSUpdateCardProps) => {
  const { t } = useTranslation();
  const [kms, setKMs] = useState("");
  const [buttonState, setButtonState] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (kms) {
      setButtonState(false);
      if (!isValidNumber(kms)) {
        setError("Enter valid kilometers");
      } else {
        setError("");
      }
    } else {
      setButtonState(true);
      setError("");
    }
  }, [kms]);

  const handleFinalSubmit = () => {
    onSubmit({ kms });
  };

  return (
    <div className="fixed animate-none inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div
        className="relative bg-popupLight dark:bg-popupDark text-primaryText dark:text-primaryTextDark shadow-lg rounded-2xl p-8 w-full max-w-lg mx-4 animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition"
        >
          <X className="w-5 h-5" />
        </button>
        <h2 className="text-2xl font-bold text-center text-primaryText dark:text-primaryTextDark mb-4">
          {t("Enter Updated KMs")}
        </h2>
        <div className="space-y-4">
          <input
            type="text"
            value={kms}
            onChange={(e) => setKMs(e.target.value)}
            className="mt-1 w-full px-4 py-2 rounded-md shadow-sm dark:bg-gray-700"
            placeholder="Tata Cliq"
          />
          <span className="text-red-500 text-sm">{error}</span>

          <button
            disabled={buttonState}
            onClick={handleFinalSubmit}
            className="flex items-center gap-2 px-4 py-2 bg-secondaryText dark:bg-secondaryTextDark text-primaryText rounded-md disabled:cursor-not-allowed disabled:opacity-60"
          >
            <Check size={18} />
            {t("Update")}
          </button>
        </div>
      </div>
    </div>
  );
};
